<template>

    <div>

        <div class="input-button-wrap">
            <label>Profile image</label>
            <div>
                <span>
                    <label for="file-input"></label>
                </span>
                <input type="file" name="file-input" id="file-input" accept="image/jpeg,image/png" @change="setImage">
                <span :class="{disabled: !avatar_key}" @click="remove">
                    <label></label>
                </span>
            </div>
            <span class="processing-feedback" :class="{show: remove_processing}"></span>
        </div>

        <div class="cropper-portal" v-if="imageSrc">

            <div class="cropper-control-btns">
                <span @click="cropImage"></span>
                <span
                    @click="uploadImage"
                    :class="{processing: processing, disabled: !croppedImageSrc}"
                ></span>
            </div>

            <div class="cropper-editor-wrapper">
                <vue-cropper
                    class="mr-2 w-50"
                    ref="cropper"
                    :guides="true"
                    :src="imageSrc"
                    :aspectRatio="1/1"
                    :initialAspectRatio="1/1"
                    @ready="doathing"
                ></vue-cropper>
            </div>
            <div class="cropper-viewer-wrapper">
                <img :src="croppedImageSrc ? croppedImageSrc : '/build/assets/dotted-circle.svg'" :class="{loaded: croppedImageSrc}">
            </div>
        </div>


<!--        <input type="file" name="image" accept="image/*" @change="setImage" />-->
<!--        <img :src="imageSrc" style="width: 100px;" />-->

        <!-- Cropper container -->
<!--        <div-->
<!--            v-if="this.imageSrc"-->
<!--            class="my-3 d-flex align-items-center justify-content-center mx-auto"-->
<!--        >-->


        <!-- Cropped image previewer -->
<!--        <img class="ml-2 w-50 bg-light" :src="croppedImageSrc" style="width:300px" />-->
<!--        </div>-->
<!--        <button v-if="this.imageSrc" @click="cropImage">Crop</button>-->
<!--        <button v-if="this.croppedImageSrc" @click="uploadImage">Upload</button>-->

    </div>

</template>

<script>

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    components: {
        VueCropper
    },
    props: [
        'avatar_key',
        'remove_processing'
    ],
	data(){
		return {
            imageSrc: '',
            croppedImageSrc: "",
            processing: false
        }
    },
    methods: {
        setImage: function (e) {
            const file = e.target.files[0];
            if(!file.type.includes("image/")){
                alert("Please select an image file");
                return;
            }
            if(file.size > 5000000){
                alert("Sorry, this file is too large; please select an image under 5mb.");
                return false;
            }
            if(typeof FileReader === "function"){
                const reader = new FileReader();
                reader.onload = event => {
                    this.imageSrc = event.target.result;

                    // Rebuild cropperjs with the updated source
                    this.$nextTick(function () {
	                    this.$refs.cropper.replace(event.target.result);
                    });
                };
                reader.readAsDataURL(file)
            }else{
                alert("Sorry, FileReader API not supported");
            }
        },
        doathing(){
            $('.cropper-view-box').prepend("<div class='cropper-view-box-circle'></div>");
        },
        cropImage(){
            // Get image data for post processing, e.g. upload or setting image src
            this.croppedImageSrc = this.$refs.cropper.getCroppedCanvas().toDataURL()
        },
        uploadImage(){
            this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                let formData = new FormData();

                // Add name for our image
                formData.append("name", "image-name-" + new Date().getTime());

                // Append image file
                formData.append("image", blob);

                this.processing = true;
                axios.post("/api/user/update-profile-image", formData).then(response => {
                    if(response.data.success && response.data.avatar_key){
                    	this.$emit('done', response.data.avatar_key)
                    }else{
                    	alert('Sorry, an error occurred while trying to process your image. Please try again.');
                    }
                    this.imageSrc = '';
                    this.croppedImageSrc = "";
                    this.processing = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            })
        },
        remove(){
        	this.$emit('remove');
        }
    }
}

</script>
